import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, CircularProgress, Alert, Button } from "@mui/material";
import { fetchServiceAndTaxSettings, editReservationTime } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";

const BookingSettingsTap = () => {
  const [loading, setLoading] = useState(false);
  const [reservationTime, setReservationTime] = useState("");
  const [error, setError] = useState(null);
  const [inputMinutes, setInputMinutes] = useState("");
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState(null);

  // ❌ ألغينا أي تحويلات — سنعرض القيمة كما تأتي من الـ API
  const toMinutes = (val) => {
    if (val === null || val === undefined) return "";
    return String(val);
  };

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      setLoading(true);
      setError(null); 
      try {
        const res = await fetchServiceAndTaxSettings();
        console.log("📦 الرد الكامل:", res);

        let payload = null;
        if (res?.data?.settings) {
          payload = Array.isArray(res.data.settings) ? res.data.settings[0] : res.data.settings;
        } else if (res?.data) {
          payload = res.data;
        } else if (res?.settings) {
          payload = Array.isArray(res.settings) ? res.settings[0] : res.settings;
        } else {
          payload = res;
        }

        const candidates = [
          payload?.reservation_time,
          payload?.reservation?.time,
          payload?.reservationTime,
          payload?.reservation_time_hours,
          payload?.reservation
        ];

        let rawVal = "";
        for (const c of candidates) {
          if (c !== undefined && c !== null) {
            rawVal = c;
            break;
          }
        }

        if (mounted) {
          console.log("⏱️ قيمة reservation_time الخام:", rawVal);
          // 👇 نعرضها كما هي بدون تحويل
          setReservationTime(String(rawVal));
          setInputMinutes(toMinutes(rawVal));
        }
      } catch (err) {
        console.error("❌ فشل جلب إعدادات الخدمات والضرائب:", err);
        if (mounted) setError("فشل في جلب إعدادات الحجز.");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();
    return () => {
      mounted = false;
    };
  }, []);

  const handleSave = async () => {
    setSuccessMsg(null);
    setError(null);
    if (inputMinutes.trim() === "") {
      setError("أدخل قيمة صحيحة.");
      return;
    }
    setSaving(true);
    try {
      await editReservationTime(inputMinutes);
      setReservationTime(inputMinutes);
      setSuccessMsg("تم تحديث زمن الحجز.");
    } catch (err) {
      console.error("❌ فشل حفظ زمن الحجز:", err);
      setError(err.message || "فشل في حفظ زمن الحجز.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>إعدادات الحجز</Typography>

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Box sx={{ maxWidth: 360 }}>
          {/* 👇 القيمة الآن تعرض وتحفظ كما هي بدون أي تحويل */}
          <TextField
            label="مدة الحجز (بالدقائق)"
            value={inputMinutes}
            onChange={(e) => setInputMinutes(e.target.value)}
            fullWidth
            margin="normal"
            helperText={successMsg ? successMsg : "القيمة تُعرض بالدقيقة ويمكن تعديلها."}
          />

          <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 1 }}>
            <Button variant="contained" onClick={handleSave} disabled={saving}>
              {saving ? <CircularProgress size={20} /> : "حفظ"}
            </Button>
          </Box>

          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
            عرض سابق: {reservationTime || "-"}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default BookingSettingsTap;
